import React from "react";
import PropTypes from "prop-types";

const Label = props => {
  const { text, id, classes, required } = props;
  return (
    // todo: fix
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label
      className={classes}
      htmlFor={id}
      dangerouslySetInnerHTML={{ __html: required ? `${text}*` : text }}
    />
  );
};

Label.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  id: PropTypes.string.isRequired,
  classes: PropTypes.string,
  required: PropTypes.bool
};

Label.defaultProps = {
  classes: "form-item__label",
  required: false
};

export default Label;
